import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { RouterModule } from '@angular/router'
import { TablerIconsModule } from 'angular-tabler-icons'
import { IconSearch } from 'angular-tabler-icons/icons'
import { AsignacionMenuRoutingModule } from './asignacion-menu-routing.module'
import { AsignacionMenuComponent } from './asignacion-menu.component'
import { DialogAsignarMenuComponent } from './servicios-alimentos/dialog-asignar-menu/dialog-asignar-menu.component'
import { DialogReplicarMenusComponent } from './servicios-alimentos/dialog-replicar-menus/dialog-replicar-menus.component'
import { ServiciosAlimentosComponent } from './servicios-alimentos/servicios-alimentos.component'

@NgModule({
  declarations: [
    AsignacionMenuComponent,
    ServiciosAlimentosComponent,
    DialogAsignarMenuComponent,
    DialogReplicarMenusComponent
  ],
  imports: [
    MatCardModule,
    MatSortModule,
    MatButtonModule,
    MatDialogModule,
    MatBadgeModule,
    MatTableModule,
    FormsModule,
    MatSelectModule,
    RouterModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
    BrowserModule,
    CommonModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    AsignacionMenuRoutingModule,
    TablerIconsModule.pick({
      IconSearch
    })
  ]
})
export class AsignacionMenuModule {}
